export const snackbarSelector = (state) => state.alerts.snackbar;
export const dialogSelector = (state) => state.alerts.dialog;
